import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import { AddIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';
import Create from 'components/space_users/modal/create';

const CreateButton = ({ onSuccess, disabled }) => {
  const setInfo = useInfo();
  const { addModal, removeModal } = useModal();

  return (
    <Button
      endIcon={<AddIcon />}
      disabled={disabled}
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            onSuccess={() => {
              removeModal();
              setInfo('info.user.invited');
              onSuccess();
            }}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        )
      }
      variant="contained"
    >
      <ButtonSpan>
        <FormattedMessage id="button.user.invite" />
      </ButtonSpan>
    </Button>
  );
};

export default CreateButton;
